export class notificationAlertTypes{
   email:boolean=false;
   sms:boolean=false;
   push:boolean=false;
}
